var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBarOpc'),_c('v-main',[_c('HeroSection'),_c('LevelSection'),_c('CategorySection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }